import { restRequest } from "vrcore-dashboard/dist/utilities";

export const GET_REPORTS = restRequest(
    "VRCORE.HOLIDAY_REQUEST_MANAGER.GET_REPORTS"
);
export const SET_ROWS_PER_PAGE =
    "VRCORE.HOLIDAY_REQUEST_MANAGER.SET_ROWS_PER_PAGE";
export const SET_PAGE = "VRCORE.HOLIDAY_REQUEST_MANAGER.SET_PAGE";
export const SET_HOLIDAY_REQUEST_STATUS = restRequest(
    "VRCORE.HOLIDAY_REQUEST_MANAGER.SET_HOLIDAY_REQUEST_STATUS"
);
